/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@charset \"UTF-8\";.app-expansion-panel-header:focus{outline:0}.app-panel-header-content{padding:0 15px 0 0;background-color:#0669b2;color:#fff;font-size:16px;cursor:pointer;height:50px;display:flex;align-items:center}.app-panel-header-content:hover{background-color:#055a99}.app-expansion-panel-header-title{margin-left:35px}.indicator-expanded.app-expansion-indicator:first-child svg{stroke:none;fill:#c5d1de}.indicator-expanded.app-expansion-indicator:not(:first-child) svg{stroke:none;fill:#dee7f0}"];
export { styles as styles };
